/* Account-scoped coupon status. Input must come from an authenticated server,
   never from localStorage, a URL customer id, or a browser-wide discount list. */
(function (host) {
  'use strict';
  function classify(wallet, now) {
    now = now == null ? Date.now() : now;
    if (!wallet || wallet.status !== 'verified' || !Array.isArray(wallet.coupons) ||
        !Number.isFinite(Date.parse(wallet.checkedAt)) ||
        now - Date.parse(wallet.checkedAt) > 60000 || Date.parse(wallet.checkedAt) > now + 5000) {
      return {status: 'unavailable', coupons: [], availableCount: null};
    }
    const coupons = wallet.coupons.map(c => {
      let state = 'unknown';
      const start = c.startsAt ? Date.parse(c.startsAt) : null;
      const end = c.endsAt ? Date.parse(c.endsAt) : null;
      const validDates = (!c.startsAt || Number.isFinite(start)) && (!c.endsAt || Number.isFinite(end));
      if (c.usedByCustomer === true && c.oncePerCustomer === true) state = 'used';
      else if (validDates && end !== null && end <= now) state = 'expired';
      else if (validDates && start !== null && start > now) state = 'scheduled';
      else if (c.ruleStatus !== 'ACTIVE') state = 'inactive';
      else if (validDates && c.entitlementVerified === true && (c.oncePerCustomer === false || c.usedByCustomer === false) &&
               c.usageLimitReached === false && typeof c.code === 'string' && c.code.trim()) state = 'available';
      return {...c, state};
    });
    return {status: 'verified', coupons, availableCount: coupons.filter(c => c.state === 'available').length};
  }
  if (typeof module === 'object' && module.exports) module.exports = {classify};
  else host.CornerCouponWalletState = {classify};
})(typeof window === 'undefined' ? {} : window);
